//search content é só extension point pra mostrar shelf ou 404
const SearchContent = ({ blocks, mzShowNotFound }: any) => {
	//   <SearchContentProvider {...props}>
	//     <SearchContentContainer>
	//       {props.canvasWidth < 640 ? props.blocks :
	//         (
	//           <>
	//             {props.blocks}
	//             {props.blocks}
	//             {props.blocks}
	//           </>
	//         )
	//       }
	//     </SearchContentContainer>
	//   </SearchContentProvider>
	if (mzShowNotFound) {
		return null;
	}
	return blocks;
};

export default SearchContent;
